import { Link } from "react-router-dom";

// 入会フローの段切替（①Form 申込フォーム → ②Thanks 完了ページ）。
// admin のモノクロ・クロームに合わせ白基調。active で現在段を指定。
const seg = {
  display: "inline-flex",
  alignItems: "center",
  background: "#14121b",
  border: "1px solid rgba(255,255,255,0.09)",
  borderRadius: "10px",
  padding: "4px",
  margin: "0 0 14px",
};
const btn = {
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "12px",
  padding: "7px 14px",
  borderRadius: "7px",
  color: "#9b99a6",
  textDecoration: "none",
};
const btnOn = { ...btn, background: "#2c2839", color: "#ffffff", fontWeight: 500 };
const num = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "18px",
  height: "18px",
  borderRadius: "50%",
  fontSize: "11px",
  background: "rgba(255,255,255,0.12)",
  color: "#cfcbe6",
};
const numOn = { ...num, background: "#ffffff", color: "#16141d" };
const divider = {
  width: "14px",
  height: "1px",
  background: "rgba(255,255,255,0.14)",
  margin: "0 2px",
};

export default function MembershipStepper({ active }) {
  const onForm = active === "form";
  const onThanks = active === "thanks";
  return (
    <div style={seg}>
      <Link to="/membership" style={onForm ? btnOn : btn}>
        <span style={onForm ? numOn : num}>1</span>Form
      </Link>
      <span style={divider}></span>
      <Link to="/membership/thanks" style={onThanks ? btnOn : btn}>
        <span style={onThanks ? numOn : num}>2</span>Thanks
      </Link>
    </div>
  );
}
